<template>
  <div v-if="entities && showSearch" v-click-outside="clickedOutsideSearchResult" class="instant-result">
    <template v-if="showDidYouMean">
      <div class="instant-result__did-you-mean">
        {{ tStatic('searchResultDidYouMean') }}:
        <span
          v-for="item of entities.items.didYouMean"
          :key="`did-you-mean-${item}`"
          class="instant-result__did-you-mean-item"
          v-html="searchResultHtml(item)">
        </span>
      </div>
    </template>

    <div v-if="emptySearchResult" class="instant-result__no-results-search">
      <div>{{ tStatic('searchAgain') }}</div>
      <div class="instant-result__no-results-search-description">
        {{ tStatic('searchAgainDescription') }}
      </div>
    </div>

    <template v-if="!emptySearchResult">
      <oie-instant-search-result-section
        :translations="{ title: tStatic('items') }"
        endpoint="items"
        :data="entities.items"
        class="instant-result__products"
        :entities="entities"
        :use-image="true"></oie-instant-search-result-section>

      <div class="instant-result__aside">
        <oie-instant-search-result-section
          :translations="{ title: tStatic('models') }"
          endpoint="models"
          :entities="entities"
          :data="entities.models"></oie-instant-search-result-section>

        <oie-instant-search-result-section
          :translations="{ title: tStatic('categories') }"
          endpoint="categories"
          :data="entities.categories"
          :entities="entities"
          class="instant-result__aside-categories"></oie-instant-search-result-section>
      </div>
    </template>
  </div>
</template>

<script>
import { createSearchResultQueryParams } from '@/core/search-service'

export default {
  data: () => ({
    entities: null,
    showSearch: false
  }),
  computed: {
    emptySearchResult() {
      return (this.entities.items.totalCount === null || this.entities.items.totalCount === 0) && (this.entities.categories.totalCount === null || this.entities.categories.totalCount === 0) && (this.entities.models.totalCount === null || this.entities.models.totalCount === 0)
    },
    showDidYouMean() {
      return this.entities.items.didYouMean && this.entities.items.didYouMean.length > 0 && (this.entities.items.totalCount === null || this.entities.items.totalCount === 0) && (this.entities.categories.totalCount === null || this.entities.categories.totalCount === 0) && (this.entities.models.totalCount === null || this.entities.models.totalCount === 0)
    }
  },
  mounted() {
    this.subscribe('instantsearch.entities.changed', (entities) => {
      this.entities = entities
    })
    this.subscribe('search.show', value => {
      this.showSearch = value
    })
  },
  methods: {
    clickedOutsideSearchResult(e) {
      const searchBox = document.querySelector('.instant-search__input')

      if(e.target !== searchBox && document.activeElement !== searchBox) {
        this.showSearch = false
        this.entities = null

        this.publish('instantsearch.clickoutside.clear.search')
      }
    },
    searchResultUrl(itemId) {
      const params = createSearchResultQueryParams(itemId, this.entities, this.endpoint)
      return `${this.clientModel.searchResultPageUrl}?${params}`
    },
    isHtml(item) {
      const htmlRegex = /<\/?[a-z][\s\S]*>/i
      return htmlRegex.test(item)
    },
    searchResultHtml(item) {
      if (this.isHtml(item)) {
        return item
      } else {
        return `<a class="instant-result__did-you-mean-item" href="${this.searchResultUrl(item)}">${item}</a>`
      }
    }
  }
}
</script>

<style lang="scss">
    .instant-result {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      max-height: calc(100vh - 7.5rem);
      background-color: color(background-white);
      border-radius: 0 0 other(border-radius) other(border-radius);
      box-shadow: 0 0 5px 0 rgba(119, 119, 119, .5);
      padding: measure(half);
      color: color(text);
      overflow-y: auto;

      @include media(small) {
        flex-direction: row;
        flex-wrap: wrap;
      }

      @include media(medium) {
        top: 4.5rem;
        right: initial;
        max-height: calc(86vh - 4.5rem);
      }
    }

    .instant-result__no-results-search {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 3rem;
      padding: measure(eighth) measure(quarter);
      text-align: center;
      flex-direction: column;
    }

    .instant-result__no-results-search-description {
        border: 1px solid #44B1FA;
        padding: 0.6rem;
        margin-top: .5rem;
        max-width: 40rem;
    }

    .instant-result__did-you-mean {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: measure(half);
    }

    .instant-result__did-you-mean-item {
      @include reset-link;
      @include body;
      display: flex;

      &::before {
        content: ',';
        display: inline-block;
        margin-right: measure(eighth);
      }

      &:first-child {
        margin-left: measure(eighth);

        &::before {
          display: none;
        }
      }

      &:hover {
        text-decoration: underline;
      }
    }

    .instant-result__products {
      margin-right: measure(full);
      margin-bottom: measure(half);

      @include media(small) {
        margin-bottom: 0;
      }
    }

    .instant-result__aside {
      flex-shrink: 0;

      @include media(small) {
        width: 20rem;
      }

      @include media(medium) {
        width: 28.125rem;
      }
    }

    .instant-result__aside-categories {
      margin-bottom: measure(half);
    }
</style>
